import { IJsonQueryTerm } from './term';

export enum ECompilationType {
  /** Последний шанс купить со скидкой **/
  LastChanceDiscount = 'lastChanceDiscount',
  /** Топ акций **/
  TopPromos = 'topPromos',
}

export type IJsonQueryCompilationType = IJsonQueryTerm<ECompilationType>;
